import { Layout } from 'components/Layout'
import { PathsEnum } from 'pages/Paths'
import { Navigate, Route, Routes } from 'react-router-dom'
import { FileShare } from './FileShare'
import { FileShareFileList } from 'features/fileshare/components'

export const FileShareRouter = () => {
  return (
    <Layout>
      <Routes>
        <Route path={PathsEnum.root} element={<FileShare />}>
          <Route path={PathsEnum.root} element={<Navigate to={PathsEnum.fileShareFiles} />} />
          <Route path={PathsEnum.fileShareFiles} element={<FileShareFileList />} />
        </Route>
      </Routes>
    </Layout>
  )
}
